import api from "@/api/api-v2-config";

export async function postDeliveryAxios(delivery) {    
    return await api.post("deliverys", delivery);
}

export async function getDeliveryListAxios() {    
    return await api.get("deliverys");
}

export async function getDeliveryIDAxios(id) {    
    return await api.get("deliverys/"+ id);
}

export async function putDeliveryAxios(payload) {  
    return await api.put("deliverys/" + payload.id, payload); 
}

export async function deleteDeliveryAxios(id) {    
    return await api.delete("deliverys/" + id);
}

export async function putDeliveryStatusAxios(id) {    
    return await api.get(`deliverys/${id}/status`);
}

export async function postDeliveryItemAxios(item) {    
    return await api.post("deliverys/item", item);
}

export async function postDeliveryItemsAxios(items) {    
    return await api.post("deliverys/items", items);
}

export async function getDeliveryItemListAxios(deliveryID) {    
    return await api.get("deliverys/item?deliveryID=" + deliveryID);
}

export async function getDeliveryItemIDAxios(id) {    
    return await api.get("deliverys/item/"+ id);
}

export async function putDeliveryItemAxios(item) {    
    return await api.put("deliverys/item/" + item.id, item);
}

export async function deleteDeliveryItemAxios(id) {    
    return await api.delete("deliverys/item/" + id);
}

export async function putDeliveryItemStatusAxios(id, payload) {    
    return await api.put(`deliverys/item/${id}/status`, payload);
}

export async function getDeliverySignatureIDAxios(id) {    
    return await api.get("deliverys/signature/"+ id);
}

export async function postDeliverySignatureAxios(payload) {    
    return await api.post("deliverys/signature", payload);
}
